import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import SiteChrome from './SiteChrome';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      await api.forgotPassword(email, 'Influencer');
      setMessage('If an account exists for that email, a password reset link has been sent.');
    } catch (err) {
      setError(err.message || 'Unable to send the reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <SiteChrome>
      <div className="max-w-md mx-auto px-5 sm:px-6 py-10 sm:py-12">
        <div className="bg-white rounded-2xl shadow-lg p-5 sm:p-8">
          <div className="text-center mb-8">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Reset your password</h1>
            <p className="text-sm text-gray-600">Enter your affiliate email and we will send a reset link.</p>
          </div>

          {message && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <p className="text-green-800 text-sm">{message}</p>
            </div>
          )}

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <p className="text-red-800 text-sm">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-600 focus:border-transparent"
                placeholder="john@example.com"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary-600 text-white text-sm py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {loading ? 'Sending reset link...' : 'Send Reset Link'}
            </button>
          </form>

          <div className="mt-8 text-center">
            <Link to="/login" className="text-sm text-primary-600 hover:underline font-medium">
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    </SiteChrome>
  );
};

export default ForgotPassword;
